import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledSideMenuWrapper = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--side-menu-wrapper-width': props.$width
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  width: 100%;
  min-height: 100vh;
  
  .SideMenuWrapper-content {
    flex-grow: 1;

    .notistack-SnackbarContainer {
      width: unset; !important;

      margin-top: 0;
      margin-right: 0;
      margin-left: calc(${props => props.$css.$var('--side-menu-wrapper-width', false)} - ${props => props.theme.layout('0.5sp')});
      margin-bottom: -${props => props.theme.layout('0sp')};
    }
  }

  &.SideMenuWrapper {
    > .SideMenuWrapper {
      &-drawer {
        &.MenuDrawer-persistent {
          > .MuiPaper-root {
            transition: unset !important;
          }
        }
      }
    }
  }

  &.SideMenuWrapper-animate.SideMenuWrapper {
    &-open {
      > .SideMenuWrapper {
        &-drawer {
          &.MenuDrawer-persistent {
            > .MuiPaper-root {
              transition: ${props => props.theme.transitions.create(['width'], {
                easing: props.theme.property('transitions.easing.easeIn'),
                duration: props.theme.property('transitions.duration.enteringScreen')
              })} !important;
            }
          }
        }
        
        &-content {
          transition: ${props => props.theme.transitions.create(['margin-left'], {
            easing: props.theme.property('transitions.easing.easeIn'),
            duration: props.theme.property('transitions.duration.enteringScreen')
          })} !important;
          
          .PageBar {
            transition: ${props => props.theme.transitions.create(['left', 'width'], {
              easing: props.theme.property('transitions.easing.easeIn'),
              duration: props.theme.property('transitions.duration.enteringScreen')
            })} !important;
          }
        }
      }
    }

    &:not(.SideMenuWrapper-open) {
      > .SideMenuWrapper {
        &-drawer {
          &.MenuDrawer-persistent {
            > .MuiPaper-root {
              transition: ${props => props.theme.transitions.create(['width'], {
                easing: props.theme.property('transitions.easing.sharp'),
                duration: props.theme.property('transitions.duration.leavingScreen')
              })} !important;
            }
          }
        }

        &-content {
          transition: ${props => props.theme.transitions.create(['margin-left'], {
            easing: props.theme.property('transitions.easing.sharp'),
            duration: props.theme.property('transitions.duration.leavingScreen')
          })} !important;
          
          .PageBar {
            transition: ${props => props.theme.transitions.create(['left', 'width'], {
              easing: props.theme.property('transitions.easing.sharp'),
              duration: props.theme.property('transitions.duration.leavingScreen')
            })} !important;
          }
        }
      }
    }
  }

  ${props => props.theme.breakpoints.down('sm')} {
    .SideMenuWrapper-content {
      .notistack-SnackbarContainer {
        margin-left: calc(${props => props.$css.$var('--side-menu-wrapper-width', false)} - ${props => props.theme.layout('0.75sp')});
        margin-bottom: -${props => props.theme.layout('0.5sp')};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledSideMenuWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledSideMenuWrapper;
